export const COMPONENT_NAME = "default-layout";
